import { useNavigate } from 'react-router-dom';
import CloseButton from '../../components/CloseButton';
import './create-module.css';
import { useEffect, useState } from 'react';
import Input from '../../components/Input';
import PhotoInput from '../../components/PhotoInput';
import Dropdown from '../../components/Dropdown';
import { create, get, post } from '../../services/api';
import { useUI } from '../../UIContext';
import { handleErr } from '../../utils/functions';
import CheckInput from '../../components/CheckInput';

function CreateModule() {
    const navigate = useNavigate();

    const { setLoading, setMessage } = useUI();
    const [instructors, setInstructors] = useState([]);
    const [selectedInstructorId, setSelectedInstructorId] = useState('');
    const [name, setName] = useState('');
    const [supplementary, setSupplementary] = useState(false);
    const [image, setImage] = useState(undefined);
    const [submitAttempt, setSubmitAttempt] = useState(false);
    const [hasSavedProcess, setHasSavedProcess] = useState(false);

    useEffect(() => {
        async function getInstructors() {
            setLoading(true);

            await get('/instructor', true, setMessage,
                (response) => {
                    const data = Array.isArray(response.data) ? response.data : Object.values(response.data || {});
                    setInstructors(data);
                },
                (err) => {
                    handleErr(setMessage, `Não foi possível carregar os professores: ${err}`);
                },
                () => {
                    setLoading(false);
                }
            );
        }

        getInstructors();
    }, [setInstructors, setLoading, setMessage]);

    function isNameValid() {
        return !!name && name.length >= 2 && name.length <= 56;
    }

    function clearScreen() {
        setName('');
        setImage(undefined);
        setSelectedInstructorId('');
        setSubmitAttempt(false);
    }

    async function onClickSave(e) {
        function isSaveValid() {
            setSubmitAttempt(true);

            return isNameValid() && !!selectedInstructorId;
        }

        function showSuccess() {
            setHasSavedProcess(true);
            setMessage({ type: 'success', text: 'O módulo foi cadastrado com sucesso.' });
        }

        e.preventDefault();

        if (!isSaveValid())
            return;

        setLoading(true);

        const data = {
            name,
            supplementary,
            instructorId: selectedInstructorId
        };

        await create('/module', data, true, setMessage,
            async (response) => {
                if (!image) {
                    clearScreen();
                    showSuccess();
                    return;
                }

                const formData = new FormData();
                formData.append('image', image);
                await post(`module/${response.data.id}/image`, formData, true, setMessage,
                    () => {
                        clearScreen();
                        showSuccess();
                    },
                    (err) => {
                        handleErr(setMessage, `Não foi possível salvar a imagem do módulo: ${err}`);
                    }
                );
            },
            (err) => {
                handleErr(setMessage, `Não foi possível cadastrar o módulo: ${err}`);
            },
            () => {
                setLoading(false);
            }
        )
    }

    return (
        <form className='default-form'>
            <header className='container-header'>
                <h1>Novo Módulo</h1>

                <CloseButton
                    onClick={() => navigate('/modules')}
                    shouldConfirm={!hasSavedProcess}
                />
            </header>

            <div className='module-form-layout'>
                <div className='module-image-container'>
                    <PhotoInput
                        photo={image}
                        alt='Imagem'
                        onChange={(file) => setImage(file)}
                        onRemove={() => setImage(undefined)}
                    />
                </div>

                <div className='module-fields'>
                    <Input
                        className='commom-input glass-effect-15'
                        type='text'
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        onValidate={isNameValid}
                        placeholder='Nome'
                        shouldValidate={submitAttempt}
                        maxLength={100}
                        warningMsg='O nome deve conter ao menos 3 caracteres.'
                    />

                    <Dropdown
                        className='glass-effect-15'
                        itens={instructors}
                        value={selectedInstructorId}
                        onSelect={(instructor) => setSelectedInstructorId(instructor?.id ?? instructor?.value ?? '') }
                    />

                    <CheckInput
                        title='Complementar'
                        value={supplementary}
                        onChange={(e) => setSupplementary(!supplementary)}
                    />
                </div>
            </div>

            <div className='container-save-form'>
                <button
                    type='submit'
                    onClick={onClickSave}
                    className='blue-button zoom-effect'>
                    Salvar
                </button>
            </div>
        </form>
    );
}

export default CreateModule;